export const helpInfo = [
  {
    item: 'setups-reorders-actions',
    steps: [
      {
        title: 'Actions',
        text: '1 - Edit the Attribute\n2 - Bulk Copy\n3 - Manage Attribute Destination Assignments\n4 - Delete the Attribute',
        img: '/images/help/reorder-attributes.png',
        access: null,
      },
    ],
  },
  {
    item: 'setups-reorders-stations',
    steps: [
      {
        title: 'Actions',
        text: '1 - Edit the Station\n2 - Manage the Reason Filters\n3 - Delete the Station',
        img: '/images/help/reorder-stations.png',
        access: null,
      },
    ],
  },
  {
    item: 'setups-reorders-users',
    steps: [
      {
        title: 'Actions',
        text: '1 - Edit the User\n2 - Reset Password\n3 - Manage User Roles\n4 - Delete the User',
        img: '/images/help/reorder-users.png',
        access: null,
      },
    ],
  },
  {
    item: 'setups-reorders-roles',
    steps: [
      {
        title: 'Actions',
        text: '1 - Edit the Role\n2 - Manage Role Permissions\n3 - Delete the Role',
        img: '/images/help/reorder-roles.png',
        access: null,
      },
    ],
  },
  {
    item: 'setups-reorders-permissions',
    steps: [
      {
        title: 'Actions',
        text: '1 - Edit the Permission\n2 - Assign Permission to Role\n3 - Remove Permission from Role',
        img: '/images/help/reorder-permissions.png',
        access: null,
      },
    ],
  },
  {
    item: 'setups-reorders-customers',
    steps: [
      {
        title: 'Actions',
        text: '1 - Edit the Customer\n2 - Manage Customer Groups\n3 - Delete the Customer',
        img: '/images/help/reorder-customers.png',
        access: null,
      },
    ],
  },
  {
    item: 'setups-reorders-suppliers',
    steps: [
      {
        title: 'Actions',
        text: '1 - Edit the Supplier\n2 - Manage Supplier Products\n3 - Delete the Supplier',
        img: '/images/help/reorder-suppliers.png',
        access: null,
      },
    ],
  },
  {
    item: 'setups-reorders-products',
    steps: [
      {
        title: 'Actions',
        text: '1 - Edit the Product\n2 - Manage Product Categories\n3 - Delete the Product',
        img: '/images/help/reorder-products.png',
        access: null,
      },
    ],
  },
  {
    item: 'setups-reorders-orders',
    steps: [
      {
        title: 'Actions',
        text: '1 - Edit the Order\n2 - Manage Order Status\n3 - Delete the Order',
        img: '/images/help/reorder-orders.png',
        access: null,
      },
    ],
  },
  {
    item: 'setups-reorders-invoices',
    steps: [
      {
        title: 'Actions',
        text: '1 - Edit the Invoice\n2 - Manage Invoice Items\n3 - Delete the Invoice',
        img: '/images/help/reorder-invoices.png',
        access: null,
      },
    ],
  },
  {
    item: 'setups-reorders-shipments',
    steps: [
      {
        title: 'Actions',
        text: '1 - Edit the Shipment\n2 - Manage Shipment Tracking\n3 - Delete the Shipment',
        img: '/images/help/reorder-shipments.png',
        access: null,
      },
    ],
  },
  {
    item: 'setups-reorders-payments',
    steps: [
      {
        title: 'Actions',
        text: '1 - Edit the Payment\n2 - Manage Payment Methods\n3 - Delete the Payment',
        img: '/images/help/reorder-payments.png',
        access: null,
      },
    ],
  },
  {
    item: 'setups-reorders-reports',
    steps: [
      {
        title: 'Actions',
        text: '1 - Edit the Report\n2 - Manage Report Filters\n3 - Delete the Report',
        img: '/images/help/reorder-reports.png',
        access: null,
      },
    ],
  },
  {
    item: 'setups-reorders-settings',
    steps: [
      {
        title: 'Actions',
        text: '1 - Edit the Setting\n2 - Manage Setting Values\n3 - Delete the Setting',
        img: '/images/help/reorder-settings.png',
        access: null,
      },
    ],
  },
];
